import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useRoutes from "../Routes/routes.js";
import NotificationModal from "../common/NotificationModal";
import BlueScrollWindowPrompt from "../common/BlueScrollWindowPrompt";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { useEffect } from "react";
import errorHandler from "../../services/ErrorHandler/ErrorHandler.js";
import GlobalAppContext from "../../globals/GlobalAppContext.js";

const cookies = new Cookies();

const App = () => {
    const allRoutes = useRoutes();
    const { i18n } = useTranslation();
    const { t } = useTranslation("errorHandler");

    useEffect(() => {
        errorHandler.setTranslationFunction(t);
    }, [t]);

    useEffect(() => {
        const currentLanguage = cookies.get("language");
        if (currentLanguage) {
            i18n.changeLanguage(currentLanguage);
        } else {
            i18n.changeLanguage(GlobalAppContext.getBrowserLanguage());
        }
    }, [i18n]);

    const renderRoutes = (curRoutes = allRoutes) => {
        return curRoutes.map((route, i) => (
            <Route key={i} path={route.path} element={route.element}>
                {route.children &&
                    route.children.length > 0 &&
                    renderRoutes(route.children)}
            </Route>
        ));
    };

    return (
        <>
            <NotificationModal />
            <BlueScrollWindowPrompt />
            <Router>
                <Routes>{renderRoutes()}</Routes>
            </Router>
        </>
    );
};

export default App;
